import { apiFetch } from "@/lib/api";

export interface UninvoicedOpenSalesOrderLineRow {
  order_number: string;
  ship_by_date: string | null;
  client_name: string | null;
  sku: string;
  quantity: number;
  unit_price: string;
  line_value: string;
  uninvoiced_quantity: number;
  uninvoiced_value: string;
}

export interface UninvoicedOpenSalesOrdersReport {
  total: number;
  ordersWithUninvoiced: number;
  rowCount: number;
  allocation: string;
  rows: UninvoicedOpenSalesOrderLineRow[];
}

export async function fetchUninvoicedOpenSalesOrdersReport(): Promise<UninvoicedOpenSalesOrdersReport> {
  return apiFetch<UninvoicedOpenSalesOrdersReport>("/api/accounting/reports/uninvoiced-open-sales-orders");
}
